// extracted by mini-css-extract-plugin
export default {"secondary":"Forms_secondary__xJiuz","text":"Forms_text__cO1uk"};